"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = () => ({
    headerBox: {
        position: 'relative',
        margin: 0,
        padding: '19px 24px 29px 24px',
        textAlign: 'center',
        fontSize: '20px',
    },
    headerBoxRounded: {
        borderRadius: 2,
    },
    gridWrap: {
        position: 'relative',
        marginBottom: 24,
    },
    gridRoot: {
        position: 'relative',
        textAlign: 'right',
    },
});
exports.styles = styles;
